import TimeTableSelectedEvent from './TimeTableSelectedEvent';

export default TimeTableSelectedEvent;